import Navbar from '@/components/navbar/Navbar';
import { PATHS } from '@/constants/Paths';
import { useAuth } from '@/hooks/useAuth';
import { LoginState } from '@/types/auth/LoginState';
import { UserType } from '@/types/auth/UserType';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7';
import { useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router';
import { useGetMe } from '@/api/user.api';

const ProtectedRouter = () => {
  const { userInfo } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (userInfo?.state === LoginState.LOGGED_OUT) {
      navigate(PATHS.auth.login);
    }
  }, [navigate, userInfo?.state]);

  // Prevent undefined state while token is fetched from local storage
  if (userInfo?.state !== LoginState.LOGGED_IN) return;

  return <UserTypeRouter />;
};

export default ProtectedRouter;

const UserTypeRouter = () => {
  const { userInfo } = useAuth();
  const { data: userData, isSuccess } = useGetMe();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (userInfo?.state === LoginState.LOGGED_OUT) {
      navigate(PATHS.auth.login);
      return;
    }

    if (!isSuccess || !userData) return;

    // Handle root path redirection
    if (location.pathname === '/') {
      switch (userData.userType) {
        case UserType.Receiver:
          navigate(PATHS.home.dashboard);
          break;
        case UserType.Distributor:
          navigate(PATHS.distributors.dashboard);
          break;
        case UserType.Admin:
          navigate(PATHS.admin.dashboard);
          break;
      }
      return;
    }

    // Prevent access to routes meant for other user types
    const path = location.pathname;
    if (
      userData.userType === UserType.Receiver &&
      (path.startsWith('/distributors') || path.startsWith('/admin'))
    ) {
      navigate(PATHS.home.dashboard);
    } else if (
      userData.userType === UserType.Distributor &&
      (path.startsWith('/receivers') || path.startsWith('/admin'))
    ) {
      navigate(PATHS.distributors.dashboard);
    } else if (
      userData.userType === UserType.Admin &&
      (path.startsWith('/receivers') || path.startsWith('/distributors'))
    ) {
      navigate(PATHS.admin.dashboard);
    }
  }, [navigate, userInfo?.state, userData, isSuccess, location.pathname]);

  if (!isSuccess || !userData) return;

  return (
    <NuqsAdapter>
      <Navbar />
      <Outlet />
    </NuqsAdapter>
  );
};
